import ButtonLoadingContent from "../../../../shared/Loading/ButtonLoadingContent";

const Form = (vm) => {
  return (
    <form className="space-y-3" onSubmit={vm.submit}>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Nueva contraseña
        </label>
        <input
          type="password"
          required
          className="w-full px-4 py-2 border border-gray-300 focus:ring-primary-light focus:border-primary"
          value={vm.password}
          onChange={(e) => vm.setPassword(e.target.value)}
          autoComplete="new-password"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Confirmar contraseña
        </label>
        <input
          type="password"
          required
          className="w-full px-4 py-2 border border-gray-300 focus:ring-primary-light focus:border-primary"
          value={vm.confirm}
          onChange={(e) => vm.setConfirm(e.target.value)}
          autoComplete="new-password"
        />
      </div>
      <button
        type="submit"
        disabled={!vm.canSubmit()}
        className={`w-full text-white text-xs py-2 transition border border-transparent ${
          !vm.canSubmit()
            ? "bg-purple-200"
            : "bg-personalized hover:bg-white hover:text-personalized hover:border-personalized"
        }`}
      >
        <ButtonLoadingContent loading={vm.loading}>
          Actualizar contraseña
        </ButtonLoadingContent>
      </button>
    </form>
  );
};

export default Form;
